import "react/jsx-runtime";
import { ConfigService as n, ApiConfigService as u } from "@nextgen-web-framework/core";
import { useSession as a } from "../Session/SessionProvider.js";
import m from "./registries/userProfileRegistry.js";
const _ = () => {
  var i;
  const o = n.getConfigs(), t = u.getTuples(), { session: e, isAnonymous: s } = a(), r = {};
  return s() || (r.visitor_imcID = o.NEXT_PUBLIC_TENANT * 1e11 + Number(e.aboNum ?? 0), r.visitor_partyID = Number(e.partyId ?? 0)), {
    site_country: t["X-Amway-Country"],
    site_currencyCode: o.NEXT_PUBLIC_CURRENCY,
    site_language: (i = t["Accept-Language"]) == null ? void 0 : i.split("-")[0],
    visitor_userProfile: m[e.type ?? "guest"],
    ...r
  };
};
export {
  _ as useTealiumDataLayer
};
//# sourceMappingURL=TealiumScript.js.map
